import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklist = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_24914",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_24914)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.74537 15.3766L2.0835 12.7147L2.9537 11.8445L4.72454 13.6153L8.2662 10.0737L9.13641 10.9647L4.74537 15.3766ZM4.74537 9.03033L2.0835 6.36846L2.9537 5.49825L4.72454 7.26908L8.2662 3.72742L9.13641 4.61846L4.74537 9.03033ZM10.8414 13.798V12.548H17.9247V13.798H10.8414ZM10.8414 7.45179V6.20179H17.9247V7.45179H10.8414Z",
			fill: "currentColor"
		})
	})]
});
export default SvgChecklist;
